import {LoginUser} from "@/types/Component";
import moment from "moment";

export function changeNumberFormat(value: number): string | null {
    return Math.round(value).toLocaleString().replace(/^-/, '▲')
}

export function applyNumberFixed(value: number): string | null {
    return Number(value).toFixed(3).toLocaleString()
}

export function fixNumberLength(value: string): string | null {
    return value.length > 7 ? value.substring(0, 7) + '…' : value
}

export function changeDateFormat(value: string): string {
    return moment(value).format('YYYY年M月D日')
}

export function isAdmin(loginUser: LoginUser): boolean {
    return loginUser.role.find((role: string) => {
        return role === 'ADMIN'
    }) !== undefined;
}

// 削除できない理由を、対象（圃場名/作付名）ごとにグループ化して表示用メッセージを組み立てる
export function formatGroupedUsageReasons(groups: Array<{ name: string, reasons: string[] }>): string {
    return groups
        .filter(group => group.reasons.length > 0)
        .map(group => {
            const lines = group.reasons.map((reason, index) => `    ${index + 1}. ${reason}で使用されている為、削除できません。`)
            return `${group.name}:\n${lines.join('\n')}`
        })
        .join('\n\n')
}
